import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getFacturePaymentsData = async (params = {}) => {
  const response = await axios.get(`${API_URL}/facture-payments`, { params });
  return response?.data?.data ?? [];
};

export const createFacturePayment = async (payload) => {
  const response = await axios.post(`${API_URL}/facture-payments`, payload);
  return response?.data?.data ?? null;
};

export const updateFacturePayment = async (id, payload) => {
  const response = await axios.put(`${API_URL}/facture-payments/${id}`, payload);
  return response?.data?.data ?? null;
};

export const deleteFacturePayment = async (id) => {
  const response = await axios.delete(`${API_URL}/facture-payments/${id}`);
  return response?.data ?? null;
};
